// react
import { useState } from 'react';

// redux
import { useSelector } from 'react-redux';

// material-ui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';

// assets
import IconHelp from '@tabler/icons-react/dist/esm/icons/IconHelp';

// ==============================|| PROFILE MENU ||============================== //

const HelpSection = () => {
  const appConfig = useSelector((state) => state.appConfig?.data);
  const supportContact = appConfig?.generalSettings?.supportContact || 'info@atlasopen.com';

  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <span style={{ cursor: 'pointer' }}>
        <IconHelp color="#1c1463" onClick={handleOpen} size={28} stroke={1.5} />
      </span>
      <Dialog open={open} fullWidth maxWidth="sm" onClose={handleClose}>
        <DialogContent sx={{ p: 4 }}>
          <Typography variant="h2" sx={{ mb: 3 }}>
            AtlasOne Support
          </Typography>
          <Typography sx={{ mb: 2 }}>If you require any technical support and/or practice advice then please contact:</Typography>
          <Typography variant="h5">{`${supportContact}`}</Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => handleClose()} sx={{ float: 'right', marginTop: 2 }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HelpSection;
